import { render, staticRenderFns } from "./ShopeeReturn.vue?vue&type=template&id=95e77b64&"
import script from "./ShopeeReturn.vue?vue&type=script&lang=js&"
export * from "./ShopeeReturn.vue?vue&type=script&lang=js&"
import style0 from "./ShopeeReturn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports